module.exports = __webpack_public_path__ + "fa-regular-400.b5a61b229c9c92a6ac21.svg";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-regular-400.svg
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-regular-400.svg
// module chunks = styles